import React from 'react';
import { DefaultDateFormat, getFormattedClientDateTime } from '@utils/library/dateTime';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useMobxStore } from 'store/mobx';
import CONSTANTS from '../constants';
import { MayBeNullOrUndefined } from '../shared.interfaces';
import styles from './styles.module.scss';

export const FormattedDateTime: React.FC<{
  value: MayBeNullOrUndefined<string>;
}> = ({ value }: { value: MayBeNullOrUndefined<string> }) => {
  return <CustomFormattedDateTime value={value} format={DefaultDateFormat} />;
};

export const CustomFormattedDateTime = observer(
  ({ value, format, className }: { value: MayBeNullOrUndefined<string>; format: string; className?: string }) => {
    const { accountStore } = useMobxStore();
    const { utcOffsetInHours } = accountStore.generalSettings;

    return <StrictFormattedDateTime value={value} offset={utcOffsetInHours} format={format} className={className} />;
  },
);

const StrictFormattedDateTime: React.FC<{
  value: MayBeNullOrUndefined<string>;
  offset: number;
  format: string;
  className?: string;
}> = ({ value, offset, format, className }) => {
  if (!value) return null;

  const dateTime = getFormattedClientDateTime(value, offset, format);

  return <span className={className}>{dateTime}</span>;
};

export const FormattedDateTimeWithoutOffset: React.FC<{ value: string }> = ({ value }: { value: string }) => {
  return <StrictFormattedDateTime value={value} offset={0} format={DefaultDateFormat} />;
};

export const FormattedUnixDateTimeWithoutOffset: React.FC<{ value: string; dashForNothing?: boolean }> = ({
  value,
  dashForNothing = false,
}: {
  value: string;
  dashForNothing?: boolean;
}) => {
  if (dashForNothing && !value) {
    return (
      <div className={styles.dashWrapper}>
        <span className={styles.dash}>—</span>
      </div>
    );
  }

  const startUnixDate = moment.utc(CONSTANTS.START_UNIX_DATE);
  const isOpenedOrder = moment.utc(value).isSame(startUnixDate);

  if (isOpenedOrder) {
    return (
      <div className={styles.dashWrapper}>
        <span className={styles.dash}>—</span>
      </div>
    );
  }

  return <FormattedDateTimeWithoutOffset value={value} />;
};
